<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="likeName"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button v-if="$store.getters.isAdmin" no="initData" type="primary" @click="initData">{{ $t('CargoMsg.Cargo_InitData') }}</el-button>
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="101330-agGrid"
        config-module="101330"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        no="101330-pagination"
        config-module="101330"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="490px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item>
            <span slot="label" class="red">{{ $t('CargoMsg.Cargo_SequenceNumber') }}</span>
            <el-input v-model="editDialog.form.serialNo" no="serialNo" :disabled="true" />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="red">{{ $t('CargoMsg.Cargo_Code') }}</span>
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="red">{{ $t('CargoMsg.Cargo_ChineseName') }}</span>
            <el-input v-model="editDialog.form.chineseName" no="chineseName" />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="red">{{ $t('CargoMsg.Cargo_EnglishName') }}</span>
            <el-input v-model="editDialog.form.englishName" no="englishName" />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="red">{{ $t('CargoMsg.Cargo_ServiceType') }}</span>
            <el-radio-group v-model="editDialog.form.serviceType" no="serviceType">
              <el-radio :label="0" style="float:left">{{ $t('SeaExport.LocalService') }}</el-radio>
              <el-radio :label="1" style="float:left">{{ $t('CargoMsg.Cargo_PODServices') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="red">{{ $t('CargoMsg.Cargo_BusinessType') }}</span>
            <el-checkbox v-model="editDialog.form.fbaSea" no="fbaSea">FBA{{ $t('CargoMsg.Cargo_OceanFreight') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.fbaAir" no="fbaAir">FBA{{ $t('CargoMsg.Cargo_Air') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.fbaRailway" no="fbaRailway">FBA{{ $t('CargoMsg.Cargo_Railway') }}</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getValueAddedServiceList,
  saveValueAddedService,
  delValueAddedService,
  initValueAddedService,
  checkValueAddedService
} from '@/api/basicData/valueAddedServices'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import { deleteFbaChannel, getUsedFbaChannel } from '@/api/Fba/fbaChannel'

export default {
  name: 'ValueAddedServices',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNo',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceType'),
          field: 'serviceType',
          width: 200,
          valueFormatter: (params) => {
            return params.value ? this.$t('CargoMsg.Cargo_PODServices') : this.$t('SeaExport.LocalService')
          }
        },
        {
          headerName: 'FBA' + this.$t('CargoMsg.Cargo_OceanFreight'),
          field: 'fbaSea',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: 'FBA' + this.$t('CargoMsg.Cargo_Air'),
          field: 'fbaAir',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: 'FBA' + this.$t('CargoMsg.Cargo_Railway'),
          field: 'fbaRailway',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNo: '',
          code: '',
          chineseName: '',
          englishName: '',
          serviceType: 0,
          fbaSea: '',
          fbaAir: '',
          fbaRailway: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (!this.rowData) {
        this.rowData = []
        this.toQuery()
      }
    },
    // 增值服务查询
    toQuery() {
      const self = this
      const loading = getLoading()
      getValueAddedServiceList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    // 新增修改显示
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          serialNo: '',
          code: '',
          chineseName: '',
          englishName: '',
          serviceType: 0,
          fbaSea: false,
          fbaAir: false,
          fbaRailway: false
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_ValueAddedServices')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows.length > 1) {
          this.$message.warning(this.$t('common.tips.hasOneOnly'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_ValueAddedServices')
      }
      this.editDialog.visible = true
    },
    // 保存公用-新增修改
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.codeCheck'))
        return
      }
      if (!form.chineseName) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.chineseNameCheck'))
        return
      }
      if (!form.englishName) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.englishNameCheck'))
        return
      }
      if (!form.fbaSea && !form.fbaAir && !form.fbaRailway) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.fbaSeaAndAirAndRailwayCheck'))
        return
      }
      const loading = getLoading()
      saveValueAddedService(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      }).finally(() => loading.close())
    },
    // 移除
    async remove() {
      const selectedList = getGridSelected(this.gridOptions)
      const codeList = []
      selectedList.forEach(e => codeList.push(e.code))
      let usedFlag = false
      let loading = getLoading()
      await checkValueAddedService(codeList).then(res => {
        const data = res.data
        if (data && data.length > 0) {
          usedFlag = true
          this.$message.warning(this.$t('FbaJob.cannotDeleteAddedService'))
        }
      }).finally(() => loading.close())
      if (usedFlag) {
        return
      }
      getGridSelectedIds(this.gridOptions, 'uuid').then(uuidList => {
        return this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          loading = getLoading()
          return delValueAddedService(uuidList)
        }).catch(() => {
          return Promise.reject(this.$t('Message.DeletionCancelled'))
        })
      }).then(res => {
        if (res.ok) {
          loading.close()
          this.toQuery()
          this.$message({
            type: 'success',
            message: this.$t('Message.DeleteSucceeded')
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('Message.DeleteFail')
          })
        }
      }).finally(() => loading.close())
    },
    // 初始化数据
    initData() {
      if (this.total > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotInitData'))
        return
      }
      const loading = getLoading()
      initValueAddedService().then(res => {
        if (res.data && Number(res.data) > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_InitData') + this.$t('CargoMsg.Cargo_Success'))
        }
        this.filter.pageNum = 1
        this.toQuery()
      }).catch(() => {
      }).finally(() => loading.close())
    }
  }
}
</script>

